// replace all - and / with blank space
export const withOutScript = (string = '', characterToReplace= ' ') => {
  return string.replace(/[-/]/g, characterToReplace)
}

export const withBottomLine = (string = '') => {
  return string.replace(/[-/]/g, '_').toLocaleLowerCase()
}

export const censorCellPhone = cellphone => {
	const phonePrefixLength = process.env.COUNTRY_PHONE_PREFIX.length || 3
	const cellWithOutPrefix =
		cellphone.length > phonePrefixLength
			? cellphone.substr(phonePrefixLength)
			: cellphone
	return '*'.repeat(cellWithOutPrefix.length - 4) + cellWithOutPrefix.substr(-4)
}

export const censorMail = email => {
	const arr = email.split('@')
	const emailLengh = arr[0].length
	const censoredMail = '*'.repeat(emailLengh === 1 ? 2 : emailLengh - 2)
	return (
		email.substring(0, emailLengh === 1 ? 1 : 2) + censoredMail + '@' + arr[1]
	)
}